export const qrParkingUidList = new Set(["136", "251", "254", "250", "210", "999", "306", "226"]);
